import { UserTypeEntity } from '../user/user'

export enum ApiMethodEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export type ApiEntity = {
  id: number
  method: ApiMethodEnum
  path: string
  accessibleUserTypes: UserTypeEntity[]
}

export type GroupApiEntity = {
  key: string
  path: string
  children: ApiEntity[]
  accessibleUserTypes: UserTypeEntity[]
}
